import { useEffect } from "react";
import { useAppDispatch } from "../Redux/store"
import { getQuery } from "../helpers/url";
import { setGameUrl } from "../Redux/gameSlice";
import { explorerUrl } from "../const/urls";

export const useSetStoredGame = () => {
    const dispatch = useAppDispatch();
    const stored = getQuery((window.location.href)).value;
    useEffect(() => {
        if (stored) {
            dispatch(setGameUrl(`${explorerUrl}${stored}`));
        }
    }, [])
}